import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowRightSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 14 50" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m2 2 10 23L2 48"
      stroke="#FFF"
      strokeWidth={3}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgArrowRightSmall);
export default Memo;
